import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cqmsmodelwidget',
  templateUrl: './cqmsmodelwidget.component.html',
  styleUrls: ['./cqmsmodelwidget.component.css']
})
export class CqmsmodelwidgetComponent implements OnInit {
  @Input() WidgetDetails: any[]
  public showWidget: boolean = false;
  constructor() { }
  callshowWidget() {
    this.showWidget = !this.showWidget;
  }
  ngOnInit() {
  }

}
